import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Minus, Plus, X, ShoppingBag, ArrowRight, Tag } from 'lucide-react';
import Header from './components/Header25';
import Footer from './components/Footer25';

const Cart25 = () => {
    const navigate = useNavigate();
    const [couponCode, setCouponCode] = useState('');
    const [couponApplied, setCouponApplied] = useState(false);
    const [cartItems, setCartItems] = useState([
        {
            id: 1, name: 'Classic Cotton Kurta', size: 'M', color: 'Off-White',
            price: 3499, quantity: 1,
            image: 'https://images.pexels.com/photos/8310281/pexels-photo-8310281.jpeg?auto=compress&cs=tinysrgb&w=400',
        },
        {
            id: 2, name: 'Structured Nehru Jacket', size: 'L', color: 'Charcoal',
            price: 6500, quantity: 1,
            image: 'https://images.pexels.com/photos/9558577/pexels-photo-9558577.jpeg?auto=compress&cs=tinysrgb&w=400',
        },
        {
            id: 3, name: 'Chanderi Silk Dupatta', size: 'Free Size', color: 'Teal',
            price: 3200, quantity: 2,
            image: 'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=400',
        },
    ]);

    const updateQuantity = (id, delta) => {
        setCartItems(prev => prev.map(item =>
            item.id === id ? { ...item, quantity: Math.max(1, item.quantity + delta) } : item
        ));
    };

    const removeItem = (id) => {
        setCartItems(prev => prev.filter(item => item.id !== id));
    };

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const discount = couponApplied ? Math.round(subtotal * 0.1) : 0;
    const shipping = subtotal > 2000 ? 0 : 199;
    const total = subtotal - discount + shipping;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap');
                .sahaj-cart * { box-sizing: border-box; }
                .sahaj-cart { font-family: 'IBM Plex Sans', sans-serif; background: #FFFFFF; color: #111111; }
                .sahaj-cart-heading { font-family: 'Space Grotesk', sans-serif; }
            `}</style>
            <div className="sahaj-cart" style={{ minHeight: '100vh' }}>
                <Header />

                <div style={{ maxWidth: 1280, margin: '0 auto', padding: '100px 24px 80px' }}>
                    <h1 className="sahaj-cart-heading" style={{
                        fontSize: 40, fontWeight: 700, marginBottom: 8, letterSpacing: '-1px'
                    }}>
                        YOUR CART
                    </h1>
                    <p style={{ fontSize: 15, color: '#6C757D', marginBottom: 48 }}>
                        {cartItems.length} item{cartItems.length !== 1 ? 's' : ''} in your cart
                    </p>

                    {cartItems.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '80px 0' }}>
                            <ShoppingBag size={48} color="#DEE2E6" style={{ marginBottom: 24 }} />
                            <h2 className="sahaj-cart-heading" style={{ fontSize: 24, fontWeight: 600, marginBottom: 12 }}>
                                Your cart is empty
                            </h2>
                            <p style={{ color: '#6C757D', marginBottom: 32 }}>Looks like you haven't added anything yet</p>
                            <button
                                onClick={() => navigate('/template25/shop')}
                                style={{
                                    padding: '14px 40px', background: '#0D7C66', color: '#FFFFFF',
                                    border: 'none', fontSize: 14, fontWeight: 700, cursor: 'pointer',
                                    textTransform: 'uppercase', letterSpacing: '2px',
                                    fontFamily: 'Space Grotesk, sans-serif'
                                }}
                            >
                                Continue Shopping
                            </button>
                        </div>
                    ) : (
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 400px', gap: 48 }}>
                            {/* Cart Items */}
                            <div>
                                {/* Header */}
                                <div style={{
                                    display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 40px',
                                    padding: '0 0 16px', borderBottom: '2px solid #111111',
                                    fontSize: 12, fontWeight: 600, textTransform: 'uppercase',
                                    letterSpacing: '1.5px', color: '#6C757D'
                                }}>
                                    <span>Product</span>
                                    <span style={{ textAlign: 'center' }}>Price</span>
                                    <span style={{ textAlign: 'center' }}>Quantity</span>
                                    <span style={{ textAlign: 'right' }}>Total</span>
                                    <span></span>
                                </div>

                                {cartItems.map(item => (
                                    <div
                                        key={item.id}
                                        style={{
                                            display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 40px',
                                            alignItems: 'center', padding: '24px 0',
                                            borderBottom: '1px solid #DEE2E6'
                                        }}
                                    >
                                        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                                            <div style={{ width: 80, height: 80, overflow: 'hidden', flexShrink: 0 }}>
                                                <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                            </div>
                                            <div>
                                                <h3 className="sahaj-cart-heading" style={{ fontSize: 15, fontWeight: 600, margin: '0 0 4px' }}>
                                                    {item.name}
                                                </h3>
                                                <p style={{ fontSize: 13, color: '#6C757D', margin: 0 }}>
                                                    Size: {item.size} | Color: {item.color}
                                                </p>
                                            </div>
                                        </div>
                                        <span style={{ textAlign: 'center', fontSize: 14, fontWeight: 500 }}>
                                            ₹{item.price.toLocaleString('en-IN')}
                                        </span>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #DEE2E6' }}>
                                                <button
                                                    onClick={() => updateQuantity(item.id, -1)}
                                                    style={{ width: 32, height: 32, border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                >
                                                    <Minus size={14} />
                                                </button>
                                                <span className="sahaj-cart-heading" style={{ width: 32, textAlign: 'center', fontSize: 14, fontWeight: 600 }}>
                                                    {item.quantity}
                                                </span>
                                                <button
                                                    onClick={() => updateQuantity(item.id, 1)}
                                                    style={{ width: 32, height: 32, border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                >
                                                    <Plus size={14} />
                                                </button>
                                            </div>
                                        </div>
                                        <span className="sahaj-cart-heading" style={{ textAlign: 'right', fontSize: 15, fontWeight: 700 }}>
                                            ₹{(item.price * item.quantity).toLocaleString('en-IN')}
                                        </span>
                                        <button
                                            onClick={() => removeItem(item.id)}
                                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <X size={18} color="#6C757D" />
                                        </button>
                                    </div>
                                ))}

                                <button
                                    onClick={() => navigate('/template25/shop')}
                                    style={{
                                        marginTop: 24, padding: '12px 0', background: 'none',
                                        border: 'none', fontSize: 14, color: '#0D7C66',
                                        fontWeight: 600, cursor: 'pointer', display: 'flex',
                                        alignItems: 'center', gap: 8,
                                        fontFamily: 'IBM Plex Sans, sans-serif'
                                    }}
                                >
                                    ← Continue Shopping
                                </button>
                            </div>

                            {/* Order Summary */}
                            <div>
                                <div style={{ background: '#F8F9FA', padding: 32, border: '1px solid #DEE2E6' }}>
                                    <h2 className="sahaj-cart-heading" style={{
                                        fontSize: 20, fontWeight: 700, marginBottom: 24,
                                        textTransform: 'uppercase', letterSpacing: '1px'
                                    }}>
                                        Order Summary
                                    </h2>

                                    {/* Coupon */}
                                    <div style={{ marginBottom: 24 }}>
                                        <div style={{ display: 'flex', gap: 0 }}>
                                            <div style={{ position: 'relative', flex: 1 }}>
                                                <Tag size={16} color="#6C757D" style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }} />
                                                <input
                                                    type="text"
                                                    placeholder="Coupon code"
                                                    value={couponCode}
                                                    onChange={(e) => setCouponCode(e.target.value)}
                                                    style={{
                                                        width: '100%', padding: '12px 12px 12px 36px',
                                                        border: '1px solid #DEE2E6', background: '#FFFFFF',
                                                        fontSize: 14, outline: 'none',
                                                        fontFamily: 'IBM Plex Sans, sans-serif'
                                                    }}
                                                />
                                            </div>
                                            <button
                                                onClick={() => setCouponApplied(true)}
                                                style={{
                                                    padding: '12px 20px', background: '#111111', color: '#FFFFFF',
                                                    border: 'none', fontSize: 13, fontWeight: 600,
                                                    cursor: 'pointer', fontFamily: 'Space Grotesk, sans-serif',
                                                    textTransform: 'uppercase', letterSpacing: '1px'
                                                }}
                                            >
                                                Apply
                                            </button>
                                        </div>
                                        {couponApplied && (
                                            <p style={{ fontSize: 13, color: '#0D7C66', marginTop: 8, fontWeight: 500 }}>
                                                Coupon applied! 10% discount
                                            </p>
                                        )}
                                    </div>

                                    <div style={{ borderTop: '1px solid #DEE2E6', paddingTop: 20 }}>
                                        {[
                                            { label: 'Subtotal', value: subtotal },
                                            ...(couponApplied ? [{ label: 'Discount (10%)', value: -discount }] : []),
                                            { label: 'Shipping', value: shipping, note: shipping === 0 ? 'Free' : null },
                                        ].map((row, idx) => (
                                            <div key={idx} style={{
                                                display: 'flex', justifyContent: 'space-between',
                                                marginBottom: 12, fontSize: 14
                                            }}>
                                                <span style={{ color: '#6C757D' }}>{row.label}</span>
                                                <span style={{
                                                    fontWeight: 500,
                                                    color: row.value < 0 ? '#0D7C66' : '#111111'
                                                }}>
                                                    {row.note || (row.value < 0 ? '-' : '') + '₹' + Math.abs(row.value).toLocaleString('en-IN')}
                                                </span>
                                            </div>
                                        ))}
                                        {shipping === 0 && (
                                            <p style={{ fontSize: 12, color: '#0D7C66', marginBottom: 12 }}>
                                                Free shipping on orders above ₹2,000
                                            </p>
                                        )}
                                    </div>

                                    <div style={{
                                        borderTop: '2px solid #111111', paddingTop: 16, marginTop: 8,
                                        display: 'flex', justifyContent: 'space-between', alignItems: 'baseline'
                                    }}>
                                        <span className="sahaj-cart-heading" style={{ fontSize: 16, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px' }}>
                                            Total
                                        </span>
                                        <span className="sahaj-cart-heading" style={{ fontSize: 28, fontWeight: 700 }}>
                                            ₹{total.toLocaleString('en-IN')}
                                        </span>
                                    </div>

                                    <button
                                        onClick={() => navigate('/template25/checkout')}
                                        style={{
                                            width: '100%', padding: '16px', background: '#0D7C66',
                                            color: '#FFFFFF', border: 'none', fontSize: 14,
                                            fontWeight: 700, cursor: 'pointer', marginTop: 24,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                                            textTransform: 'uppercase', letterSpacing: '2px',
                                            fontFamily: 'Space Grotesk, sans-serif',
                                            transition: 'background 0.2s'
                                        }}
                                        onMouseEnter={e => e.target.style.background = '#0A9B7F'}
                                        onMouseLeave={e => e.target.style.background = '#0D7C66'}
                                    >
                                        Proceed to Checkout
                                        <ArrowRight size={18} />
                                    </button>

                                    <div style={{
                                        marginTop: 20, padding: '16px', background: '#FFFFFF',
                                        border: '1px solid #DEE2E6', textAlign: 'center'
                                    }}>
                                        <p style={{ fontSize: 12, color: '#6C757D', margin: 0 }}>
                                            Secure checkout powered by industry-standard encryption
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Cart25;
